import { render, staticRenderFns } from "./CessaoEdit.vue?vue&type=template&id=9420782e&scoped=true&"
import script from "./CessaoEdit.vue?vue&type=script&lang=js&"
export * from "./CessaoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9420782e",
  null
  
)

export default component.exports